import React from 'react';
import { useDispatch } from 'react-redux';
import { useDeleteProjectMutation, mainActions } from '../../store';
import { Modal } from '../../components';
import { WaitingModal } from './WaitingModal';

export const DeleteProjectModal = (props) => {
    const { project, onClose } = props;
    const [deleteProject] = useDeleteProjectMutation();
    const dispatch = useDispatch();

    const handleDelete = async () => {
        onClose();

        dispatch(
            mainActions.showWaitingModal({
                isSimple: true,
                msg: 'Deleting Project...Please wait...',
            }),
        );
        try {
            await deleteProject({ id: project.id });
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(mainActions.hideWaitingModal());
        }
    };

    let showModal = false;
    let projectName = '';
    if (project) {
        showModal = true;
        const { name } = project;
        projectName = name;
    }

    return (
        <>
            <Modal
                fitContent
                show={showModal}
            >
                <div className="sm:container p-4">
                    <h1>Delete this Project?</h1>
                    <div className="mb-4">
                        <div className="flex justify-between gap-4 mb-2">
                            <div>
                                <div className="swegon-ui-text-input-wrapper">
                                    <div>{projectName}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            type="button"
                            className="swegon-like-button outlined mr-4 !px-4 amber hover:cursor-pointer"
                        >
                            Cancel
                        </button>
                        <button
                            className="swegon-like-button contained red"
                            type="submit"
                            onClick={handleDelete}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </Modal>
            <WaitingModal />
        </>
    );
};
